import * as React from 'react'

import { Modal, ModalProps } from '@thg-commerce/gravity-elements'

import {
  QuickBuyModalContent,
  QuickBuyModalContentProps,
} from './AuroraQuickBuyModalContent'
import { QuickBuyModalSkeleton } from './QuickBuyModalSkeleton'

interface QuickBuyModalRendering {
  rendering: {
    open: boolean
    onClose: () => void
  }
  modal: Omit<ModalProps, 'children' | 'onClose' | 'open'>
  loading: boolean
  setOpen?: (state: boolean) => void
  inStockComponent?: React.ReactElement
  enablePreselectedProductVariant?: boolean
}

export type QuickBuyModalProps = QuickBuyModalRendering &
  QuickBuyModalContentProps

export const QuickBuyModal = ({
  rendering,
  modal,
  loading,
  i18nText,
  product,
  pricing,
  links,
  callbacks,
  quantitySelector,
  hideQuantitySelector,
  quickBuyModalTheme,
  coreTheme,
  setOpen,
  inStockComponent,
  options,
  selectedOptions,
  setSelectedOptionsCallback,
  enablePreselectedProductVariant,
  displayViewMoreInfo,
  hideAsterixOnPDP,
}: QuickBuyModalProps) => {
  return (
    <Modal
      open={rendering.open}
      onClose={rendering.onClose}
      contentPadding="0"
      verticalAlignment={['bottom', 'bottom', 'top', 'top']}
      isAutoHeightMobile={true}
      {...modal}
    >
      {loading ? (
        <QuickBuyModalSkeleton />
      ) : (
        <QuickBuyModalContent
          i18nText={i18nText}
          product={product}
          pricing={pricing}
          links={links}
          callbacks={callbacks}
          quantitySelector={quantitySelector}
          hideQuantitySelector={hideQuantitySelector}
          quickBuyModalTheme={quickBuyModalTheme}
          coreTheme={coreTheme}
          setOpen={setOpen}
          inStockComponent={inStockComponent}
          options={options}
          selectedOptions={selectedOptions}
          setSelectedOptionsCallback={setSelectedOptionsCallback}
          enablePreselectedProductVariant={enablePreselectedProductVariant}
          displayViewMoreInfo={displayViewMoreInfo}
          hideAsterixOnPDP={hideAsterixOnPDP}
        />
      )}
    </Modal>
  )
}
